export default __webpack_public_path__ + "static/media/Logo_mintjar_beta.a5caf16f.svg";